export enum EnergyStatusUiAction {
  startStatusViewUpdates = 'startStatusViewUpdates',
  stopStatusViewUpdates = 'stopStatusViewUpdates',
}

export enum EnergyStatusUiGetter {
  energyStatusViewModel = 'energyStatusViewModel',
}
